module.exports = __webpack_public_path__ + "img/waistline_upper_pocket_position.3e1d93ba.png";